export default {
  computed: {
    clientTimeZone() {
      return new Date().getTimezoneOffset() / 60;
    },
  }
}